import z from 'zod';
import {firestoreTimestampToDateSchema} from '../_other/firestore/firestoreTimestampToDateSchema';
import {questionStatusSchema} from './QuestionStatus';

export const questionReviewSchema = z.object({
  uid: z.string(),
  name: z.string().default('Unknown'),
  result: questionStatusSchema,
  timestamp: firestoreTimestampToDateSchema,
  note: z.string().optional(),
});

export type QuestionReview = z.infer<typeof questionReviewSchema>;
